<template>
  <div class="bancos-movimientos-list">
    <transition name="slide">
      <b-row>
        <b-col cols="12" xl="12">
          <b-card header="Cliente">
            <b-form>
              <template v-if="seleccionOpciones">
                <b-form-group
                  label="Cliente"
                  label-for="cliente"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons"
                        @click="seleccionarCliente">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !opciones.cliente,
                                      'fa fa-remove': opciones.cliente  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="cliente"
                      :value="opcionCliente"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>

                <app-periodo
                  label="Período"
                  :nombre="opcionPeriodoAnio"
                  :lista="anios"
                  :labelCols="labelCols"
                  @updated="periodoActualizado">
                </app-periodo>  
              </template>

              <template v-if="!seleccionOpciones">
                <b-form-group
                  label="Cliente"
                  label-for="cliente"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="cliente"
                    :value="clienteNombre"
                    readonly
                    type="text"/>
                </b-form-group>

                <b-form-group
                  label="Período"
                  label-for="periodo"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="periodo"
                    :value="periodoAnio"
                    readonly
                    type="text"/>
                </b-form-group>
              </template>

              <br>

              <b-form-group
                label="Monto Ventas"
                label-for="montoVentas"
                :label-cols="labelCols"
                description="Monto neto de ventas del período"
                horizontal>
                <b-form-input 
                  id="montoVentas"
                  :value="montoVentas | moneda"
                  readonly
                  type="text"/>
              </b-form-group>

              <b-form-group
                label="Monto Descontado"
                label-for="montoPresupuestos"
                :label-cols="labelCols"
                description="Monto descontado en presupuestos internos"
                horizontal>
                <b-form-input 
                  id="montoVentas"
                  :value="montoPresupuestos | moneda"
                  readonly
                  type="text"/>
              </b-form-group>

              <b-form-group
                label="Saldo"
                label-for="saldo"
                :label-cols="labelCols"
                description="Saldo a descontar en presupuestos"
                horizontal>
                <b-form-input 
                  id="saldo"
                  :value="saldo | moneda"
                  readonly
                  type="text"/>
              </b-form-group>

              <div slot="footer">
                <b-button size="sm" variant="primary" class="footer-button" v-if="!seleccionOpciones"
                  @click.prevent="seleccionarOpciones">Seleccionar</b-button>
                <b-button size="sm" variant="primary" class="footer-button" v-if="seleccionOpciones"
                  @click.prevent="getRebateCliente">Aceptar</b-button>
                <b-button size="sm" variant="danger" class="footer-button" v-if="seleccionOpciones"
                  @click.prevent="cancelarSeleccion">Cancelar</b-button>
              </div>
            </b-form>
          </b-card>
          
          <b-card header="Rebate">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="condiciones" 
                :fields="fields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(montoMinimo)="data">
                <template v-if="data.item.montoMinimo == 0">
                  ---.--
                </template>
                <template v-if="data.item.montoMinimo != 0">
                  {{ data.item.montoMinimo | moneda }}
                </template>
              </template>
              <template v-slot:cell(montoMaximo)="data">
                <template v-if="data.item.montoMaximo == 0">
                  ---.--
                </template>
                <template v-if="data.item.montoMaximo != 0">
                  {{ data.item.montoMaximo | moneda }}
                </template>
              </template>
              <template v-slot:cell(pjeRebate)="data">
                {{ data.item.pjeRebate | porcentaje }}
              </template>
              <template v-slot:cell(importeRebate)="data">
                <template v-if="data.item.importeRebate != 0">
                  {{ data.item.importeRebate | moneda }}
                </template>
              </template>
            </b-table>
          </b-card>

          <b-card header="Presupuestos Internos">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="presupuestosInternos" 
                :fields="fieldsPresupuestos">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(fechaRegistro)="data">
                {{  data.item.fechaRegistro | fecha  }}
              </template>
              <template v-slot:cell(cotizacionTotal)="data">
                {{ data.item.cotizacionTotal | moneda(data.item.moneda) }}
              </template>
              <template v-slot:cell(importeDescuentoRebate)="data">
                {{ data.item.importeDescuentoRebate | moneda(data.item.moneda) }}
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </transition>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <div class="fixed-btn" v-if="opcionConfigurarRebate">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="configurarRebate">
            <i class="fa fa-edit"></i>Configurar Rebate</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Periodo from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'clienteRebateDatos/getField',
  mutationType: 'clienteRebateDatos/updateField',
});

export default {
  name: 'ClientesRebate',
  components: {
    appSearchCliente: SearchCliente,
    appPeriodo: Periodo,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        { key: 'montoMinimo' },
        { key: 'montoMaximo' },
        { key: 'pjeRebate' },
        { key: 'importeRebate' }
      ],
      fieldsPresupuestos: [
        { 
          key: 'presupuestoNumero',
          label: 'Nro' 
        },
        { key: 'fechaRegistro' },
        { key: 'accion' },
        { 
          key: 'cotizacionTotal',
          label: 'Cotización',
          class: 'text-right'
        },
        { 
          key: 'importeDescuentoRebate',
          label: 'Dto. Rebate',
          class: 'text-right' 
        },
      ],

      seleccionOpciones: false,
      anios: [],
      tableBusy: false,
      labelCols: 2,
      opcionConfigurarRebate: Boolean(false),

      opciones: {
        cliente: null,
        periodo: null
      }
    }
  },
  computed: {
    ...mapFields([
      'cliente',
      'clienteNombre',
      'periodo',
      'montoVentas',
      'montoPresupuestos',
      'saldo',
      'condiciones',
      'presupuestosInternos'
    ]),
    periodoAnio() {
      if (this.periodo) {
        if (this.periodo.getFullYear() != 1900) {
          return this.periodo.getFullYear().toString();
        }
      }

      return null;
    },
    opcionCliente() {
      if (this.opciones.cliente) {
        return this.opciones.cliente.nombre;
      }
      return null;
    },   
    opcionPeriodoAnio() {
      if (this.opciones.periodo) {
        if (this.opciones.periodo.getFullYear() != 1900) {
          return this.opciones.periodo.getFullYear().toString();
        }
      }

      return null;
    },
  },
  created() {
    this.opcionConfigurarRebate = Boolean(this.$store.getters['user/tieneAccesoModulo']('ClientesConfigurarRebate'));

    this.anios = this.getAniosPeriodo();

    this.$store.dispatch('clienteRebateDatos/inicializar');
  },
  methods: {
    // getClienteRebate() {
    //   this.tableBusy = true;
    //   this.$store.dispatch('clienteRebateDatos/getClienteRebate')
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.tableBusy = false);
    // },
    seleccionarOpciones() {
      this.opciones.cliente = this.cliente;
      this.opciones.periodo = this.periodo;
      this.seleccionOpciones = true;
    },
    cancelarSeleccion() {
      this.opciones.cliente = this.cliente;
      this.opciones.periodo = this.periodo;
      this.seleccionOpciones = false;
    },
    seleccionarCliente() {
      if (this.opciones.cliente) {
        this.opciones.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();
      this.opciones.cliente = cliente;
    },
    periodoActualizado(anio) {
      this.opciones.periodo = new Date(anio, 1, 1);
    },
    getRebateCliente() {
      let clienteValido = false;
      let periodoValido = false;

      if (this.opciones.cliente) {
        if (this.opciones.cliente.id != 0) {
          clienteValido = true;
        }
      }

      if (this.opciones.periodo) {
        if (this.opciones.periodo.getFullYear() != 1900) {
          periodoValido = true;
        }
      }

      if (clienteValido & periodoValido) {
        this.seleccionOpciones = false;
        let params = {
          cliente: this.opciones.cliente,
          periodo: this.opciones.periodo
        }
        this.tableBusy = true;
        this.$store.dispatch('clienteRebateDatos/getClienteRebate', params)
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.tableBusy = false);
      }
    },
    configurarRebate() {
      this.$router.push({ name: 'ClienteRebateABM' });
    }
  },
}
</script>

<style>
  /* .bancos-movimientos-list .registro table td[aria-colindex="1"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="2"] {
    width: Calc(32% - 60px)
  }
  .bancos-movimientos-list .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="4"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="5"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="6"] {
    width: 12%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="7"] {
    width: 5%;
  }
  .bancos-movimientos-list .registro table td[aria-colindex="8"] {
    width: 60px;
  } */
</style>
